export default __webpack_public_path__ + "static/media/depositphotos_180617216-stock-illustration-german-shepherd-dog-isolated-outlined (1).d3291b9e.jpg";